import {useEffect, useState} from "react";
import * as Const from "../Const";
import axios from "axios";


function useFetchParcels(sessionId, machineNames) {
    
    const TAG = "useFetchParcels";

    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    
    useEffect(() => {
        console.log(TAG, "fetching parcels", machineNames);
        const cancelTokenSource = axios.CancelToken.source();

        const fetchData = async () => {
            // console.log(TAG, "is loading: true");
            // setIsLoading(true);

            try {
                const config = {
                    withCredentials: true,
                    headers: {
                        'Authorization': sessionId,
                    },
                    cancelToken: cancelTokenSource.token,
                };

                const requests = [];

                for (const machineName of machineNames) {
                    const url = `${Const.FIELD_API_ALL_HULLS}/${machineName}`;
                    const req = axios.get(url, config);
                    requests.push(req);
                }

                const responses = await Promise.allSettled(requests);
                const fulfilledResponses = responses.filter(r => r.status === 'fulfilled');
                console.log(TAG, "fulfilled responses", fulfilledResponses);

                const results = {};

                fulfilledResponses.forEach((response) => {
                    const res = response.value;
                    const machineName = res.data['machine'];
                    results[machineName] = res.data['parcels'].map(p => ({...p, machine: machineName}));
                });

                setIsLoading(false);
                setData(results);
                // setData({});
                // console.log(TAG, "is loading: false");

            } catch (error) {
                setError(error);
                // console.log(TAG, "is loading: false");
                // setIsLoading(false);
            }
        }
        
        
        // fetchData();
        setIsLoading(true);
        fetchData().then(_ => {
            // updateSavedParcelTimestamps(parcelUpdateTimestamps);
            // setIsLoading(false);
            console.log(TAG, "done")
        });

        return () => {
            console.log(TAG, "canceling");
            // setIsLoading(false);
            cancelTokenSource.cancel(TAG + ' component unmounting');
        }

    }, [machineNames, sessionId]);
    
    return [data, isLoading, error];
}


export default useFetchParcels;
